import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Wizard from '../../../../components/Wizard';
import CalculatorIconSVGR from '../../../../assets/svgr/CalculatorIconSVGR';
import variables from '../../../../styles/variables.module.scss';
import './styles.scss';

const LifetimeSSBenefitEstimator = () => (
  <Container>
    <Grid container className='lifetime-estimator-wrapper'>
      <Grid item xs={12} md={4} className='lifetime-estimator-description-wrapper'>
        <Box mt={{ xs: 7, md: 25, lg: 34.375 }} mr={{ md: 2 }}>
          <Typography variant='h3' className='lifetime-estimator-title'>
            Lifetime Social Security Benefit Estimator
          </Typography>
          <Typography variant='subtitle1' className='lifetime-estimator-description'>
            Complete the following questions to calculate your lifetime Social Security benefits and explore what a potential reduction could mean
            {' '}
            <span className='no-wrap-text'>to you.</span>
          </Typography>
        </Box>
      </Grid>
      <CalculatorIconSVGR fillColor={variables.calculatorSVGRFillColor} />
      <Grid item xs={12} md={8} className='wizard-container'>
        <Box
          sx={{
            mx: { xs: 0, md: 6 }, mt: { xs: 0, md: 20 }, py: { xs: 2, md: 12 }, px: { sm: 0, md: 3 },
          }}
          className='lifetime-estimator-wizard-wrapper'
        >
          <Wizard />
        </Box>
      </Grid>
    </Grid>
  </Container>
);

export default LifetimeSSBenefitEstimator;
